import {observer} from 'mobx-react';
import Celebration from './Celebration';
import {FormattedMessage} from 'react-intl';

const Anniversary = observer(({anniversary, emojiReady}) => {
  return (
    <Celebration
      employee={anniversary.employee}
      date={anniversary.publishedAt}
    >
      <FormattedMessage
        id='hr_dashboard.feed.celebrations.ANNIVERSARY_MESSAGE'
        values={{
          link: <a href={`/employees/${anniversary.employee.id}`}>
                  {anniversary.employee.name}
                </a>,
          numberOfYears: anniversary.numberOfYears
        }}
      />
      {emojiReady && <span className='ml1'>
        <em-emoji className='emoji-icon' id='tada' set='native' size='22px'></em-emoji>
      </span>}
    </Celebration>
  );
});

export default Anniversary;
